import { atom } from "recoil";

export const createDefaultNotificationsRepeatModal = () => ({
	show: false,
	loaded: true,
	data: null,
	cohortConditions: [],
	audiencePreview: {
		loading: false,
		count: null,
		sentUsers: null,
		expiredUsers: null,
		readUsers: null,
		queuedUsers: null,
		error: "",
	},
});

export const notificationsRepeatModalStore = atom({
	key: "notificationsRepeatModalStore",
	default: createDefaultNotificationsRepeatModal(),
});
